var _defs, _g, _path, _path2, _g2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7f479e2913"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123.445312 165.550781 L 686.695312 165.550781 L 686.695312 568 L 123.445312 568 Z M 123.445312 165.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c29b88ab59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 391 326 L 686.695312 326 L 686.695312 621.550781 L 391 621.550781 Z M 391 326 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f479e2913)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1a22",
    d: "M 123.445312 205.90625 C 123.445312 183.691406 141.453125 165.683594 163.667969 165.683594 L 646.332031 165.683594 C 668.546875 165.683594 686.554688 183.691406 686.554688 205.90625 L 686.554688 313.164062 L 659.738281 313.164062 L 659.738281 205.90625 C 659.738281 198.5 653.734375 192.496094 646.332031 192.496094 L 163.667969 192.496094 C 156.261719 192.496094 150.261719 198.5 150.261719 205.90625 L 150.261719 527.683594 C 150.261719 535.085938 156.261719 541.089844 163.667969 541.089844 L 351.371094 541.089844 L 351.371094 567.902344 L 163.667969 567.902344 C 141.453125 567.902344 123.445312 549.894531 123.445312 527.683594 Z M 123.445312 205.90625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1a22",
    d: "M 136.851562 259.535156 L 673.148438 259.535156 L 673.148438 286.347656 L 136.851562 286.347656 Z M 136.851562 259.535156 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1a22",
    d: "M 203.890625 447.238281 L 337.964844 447.238281 L 337.964844 474.050781 L 203.890625 474.050781 Z M 203.890625 447.238281 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c29b88ab59)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1a22",
    d: "M 539.074219 353.386719 C 472.429688 353.386719 418.40625 407.410156 418.40625 474.050781 C 418.40625 540.695312 472.429688 594.71875 539.074219 594.71875 C 605.714844 594.71875 659.738281 540.695312 659.738281 474.050781 C 659.738281 407.410156 605.714844 353.386719 539.074219 353.386719 Z M 391.59375 474.050781 C 391.59375 392.601562 457.621094 326.570312 539.074219 326.570312 C 620.527344 326.570312 686.554688 392.601562 686.554688 474.050781 C 686.554688 555.503906 620.527344 621.535156 539.074219 621.535156 C 457.621094 621.535156 391.59375 555.503906 391.59375 474.050781 Z M 391.59375 474.050781 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1a22",
    d: "M 529.441406 502.015625 L 588.5 419.335938 L 610.324219 434.917969 L 543.285156 528.769531 C 541.1875 531.710938 537.992188 533.675781 534.425781 534.226562 C 530.855469 534.78125 527.21875 533.871094 524.332031 531.703125 L 470.703125 491.480469 L 486.789062 470.03125 Z M 529.441406 502.015625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.a81b38312c6ed86f114f7abe8f0fe384.svg";
export { ForwardRef as ReactComponent };